require("./main");
const hash = CryptoJS.MD5("hsBI69O90juKhpPx").toString();
import App from "./components/views/layouts/App.vue";
// Shared data using Vuex
import store from "./store/index.js";
// Router and routes
import VueRouter from "vue-router";
import {routes} from "./routes.js";
import {sync} from 'vuex-router-sync';
import {MessageBox} from 'element-ui';
import utils from '@/utils/utils';


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};


const {checkExistsInfoUser, checkProfile, checkExistHaveARelationshipWithCompany} = utils;
const router = new VueRouter({
    mode: "history",
    base: __dirname,
    linkActiveClass: "active",
    routes: routes,
    linkExactActiveClass: "active", // active class for *exact* links.
    history: true,
    saveScrollPosition: false,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
//		return $('html,body').animate({scrollTop: 0 }, 0);
    }
});

router.beforeEach(async (to, from, next) => {

    if (to && to.meta && to.meta.onlyGuest === true) {

        if (window.sessionStorage.getItem("sre_young_token")) {
            next("/");
        } else {
            next();
        }
    } else if (to && to.meta && to.meta.auth === false) {
        next();
    } else {
        if (to && to.meta && to.meta.auth === true) {
            if (window.sessionStorage.getItem("sre_young_token")) {
                if (await checkExistsInfoUser() === true) {
                    // validation of profile
                    if (to && to.meta && to.meta.requiredProfile) {
                        if (checkProfile(...to.meta.requiredProfile) === true) {


                            if (to && to.meta && to.meta.haveARelationshipWithCompany === true) {

                                if (checkExistHaveARelationshipWithCompany() === true) {
                                    next();
                                } else {
                                    store.dispatch('notifications/custom', {
                                        title: 'Permiso Denegado',
                                        msg: 'Es necesario estar vinculado a una empresa para acceder a la página solicitada',
                                        icon: 'fas fa-shield-alt text-size-17 text-color-green',
                                        duration: 0
                                    }, {root: true});
                                    next('/');
                                }


                            } else {
                                next();
                            }


                        } else {
                            store.dispatch('notifications/custom', {
                                title: 'Permiso Denegado',
                                msg: 'El usuario no tiene permiso para abrir la página solicitada',
                                icon: 'fas fa-shield-alt text-size-17 text-color-green',
                                duration: 0
                            }, {root: true});
                            next('/');
                        }
                    } else {
                        next();
                    }
                } else {

                    next('/login');
                }
            } else {
                next('/login');
            }
        } else {

            next('/login');
        }
    }

});

window.axios.interceptors.request.use(function (config) {
    if (config && config.data && window.acceptC == true) {
        let dataApp = JSON.stringify(config.data);
        dataApp = CryptoJS.AES.encrypt(dataApp, hash).toString();
        config.data = {
            'encrypt': dataApp
        };
    }
    if (config && config.params && window.acceptC == true) {

        let paramsApp = JSON.stringify(config.params);
        paramsApp = CryptoJS.AES.encrypt(paramsApp, hash).toString();
        config.params = {
            'encryptParams': paramsApp
        };
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
    if (response && response.data && window.acceptC == true) {
        if (response.config &&
            response.config.responseType &&
            response.config.responseType == 'blob') {

        } else {
            let bytes = CryptoJS.AES.decrypt(response.data.toString(), hash);
            let plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            response.data = plaintext;
        }


    }
    return response;
}, function (error) {
    const originalRequest = error.config;

    if (error.response && error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        router.push('/');
    } else if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        delete window.axios.defaults.headers.common["Authorization"];
        window.sessionStorage.removeItem('sre_young_token');
        window.axios.defaults.headers.common = {
            'Authorization': 'Bearer'
        };
        router.push('/login');
    } else if (error.response && error.response.data && (error.response.status === 400 || error.response.status === 500) && window.acceptC == true) {

        if (error.response.config &&
            error.response.config.responseType &&
            error.response.config.responseType == 'blob') {

        } else {
            let bytes = CryptoJS.AES.decrypt(error.response.data.toString(), hash);
            let plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            error.response.data = plaintext;
        }
        return Promise.reject(error);
    } else {
        return Promise.reject(error);
    }
});

sync(store, router);


new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App),
    data() {
        return {
            idleActive: false
        }
    },
    onIdle() {
        if ( window.sessionStorage.getItem("sre_young_token") && this.idleActive === false) {
            this.idleActive = true;
            this.removeSession();
        }
    },
    methods: {
        removeSession() {
            let closeIn60Seconds = setTimeout(() => {
                store
                    .dispatch("setLogOut")
                    .then(res => {

                        this.idleActive = false;
                        MessageBox.close();
                        location.reload();

                    })
                    .catch(error => {
                        console.log("error:", error);
                        this.idleActive = false;
                        MessageBox.close();
                        location.reload();

                    });
            }, 30000); // Will close on 30 seconds

            this.$confirm(
                'La aplicación se cerrará en los próximos 30 segundos, ningún cambio será guardado.',
                'La sessión expirará pronto',
                {
                    confirmButtonText: 'Continuar en la aplicación',
                    showClose: false,
                    showCancelButton: false,
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    type: 'warning',
                    center: true
                })
                .then(_ => {
                    this.idleActive = false;
                    clearTimeout(closeIn60Seconds);
                    done();
                })
                .catch(_ => {

                });
        }
    }
});
